
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof STATIC_FILE_PATH !== "string") {
    throw new Error("WebpackRequireFrom: 'STATIC_FILE_PATH' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return STATIC_FILE_PATH;
} catch (e) {
  if (!true) {
    console.error(e);
  }
  return "/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});